export enum ProductDomainEnum {
  Spark = 1,
  Advest = 2,
  EmbedLite = 3,
  DigitalBank = 4,
}

export enum OtpUseType {
  Onboarding = 1,
  AddOrUpdateCustomerOtherBankAccount = 2,
  LoanApplication = 3,
}
